/**
 * Frontend Release History (Internal user)
 *
 * This file tracks all internal user frontend releases with their versions,
 * builds, and deployment information.
 */

const RELEASES = [
  {
    id: 'int-v4.3.0+05',
    version: 'int-v4.3.0',
    title: 'Add post-exam application support',
    build: {
      number: '05',
      author: 'symeon',
      startDate: '2025-12-08',
      date: '2025-12-10',
      issues: [90, 97],
      commit: {
        message: 'Add build metadata to releases and display in footer tooltips',
        date: '2025-12-10',
        sha: '34e3e404fb3cac2fa0260682ec49105e69fed817'
      }
    }
  },
  {
    id: 'int-v4.3.0+04',
    version: 'int-v4.3.0',
    title: 'Add post-exam application support',
    build: {
      number: '04',
      author: 'symeon',
      startDate: '2025-12-04',
      date: '2025-12-08',
      issues: [90, 97],
      commit: {
        message: 'Update post-exam application creation button caption. Adjust grade form item height.',
        date: '2025-12-08',
        sha: '449405f51bb1961a21140aea57d6d30ba951139d'
      }
    }
  },
  {
    id: 'int-v4.3.0+03',
    version: 'int-v4.3.0',
    title: 'Add post-exam application support',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-12-03',
      date: '2025-12-03',
      issues: [90],
      commit: {
        message: 'Update patch version number',
        date: '2025-12-03',
        sha: 'f1f0d0d920cbaa4f3aa100ddc38863bcb1f6c44f'
      }
    }
  },
  {
    id: 'int-v4.3.0+02',
    version: 'int-v4.3.0',
    title: 'Add post-exam application support',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-12-02',
      date: '2025-12-03',
      issues: [90],
      commit: {
        message: 'Update post-exam application support texts',
        date: '2025-12-03',
        sha: 'ebaebd3d72c691fae9fe38f1d47311b789b3597b'
      }
    }
  },
  {
    id: 'int-v4.3.0+01',
    version: 'int-v4.3.0',
    title: 'Add post-exam application support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-12-01',
      date: '2025-12-01',
      issues: [90],
      commit: {
        message: 'Add post-exam application support',
        date: '2025-12-01',
        sha: 'ce66c1849d4aecefa31e021779e1ffd7a0e79a63'
      }
    }
  },
  {
    id: 'int-v4.3.0-rc.1+03',
    version: 'int-v4.3.0-rc.1',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-11-28',
      date: '2025-12-01',
      issues: [90],
      commit: {
        message: 'Fix enabled final save button without grade input on Proponent UI. Update UI text.',
        date: '2025-12-01',
        sha: '6085333f03001e442296d76dee28f33293d44dfa'
      }
    }
  },
  {
    id: 'int-v4.3.0-rc.1+02',
    version: 'int-v4.3.0-rc.1',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-11-28',
      date: '2025-11-28',
      issues: [90],
      commit: {
        message: 'Show release button on President to Print decision UI',
        date: '2025-11-28',
        sha: 'ef307e18421355cf77400a1b57c99a42d7d51d2e'
      }
    }
  },
  {
    id: 'int-v4.3.0-rc.1+01',
    version: 'int-v4.3.0-rc.1',
    title: 'Add post-exam application support (RC)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-27',
      date: '2025-11-27',
      issues: [90],
      commit: {
        message: 'Add President finalization post-exam application support',
        date: '2025-11-27',
        sha: '300f009050c2d4e070273929a3b2c7dd7f11cb0c'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.6+01',
    version: 'int-v4.3.0-dev.6',
    title: 'Add Print Decision post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-25',
      date: '2025-11-27',
      issues: [90],
      commit: {
        message: 'Add Print Decision post-exam application support',
        date: '2025-11-27',
        sha: 'b635735bb5e3f528a2acf8cb8701af05f4e0933c'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.5+01',
    version: 'int-v4.3.0-dev.5',
    title: 'Add President (to Print Decision) post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-25',
      date: '2025-11-25',
      issues: [90],
      commit: {
        message: 'Add President (to Print Decision) post-exam application support',
        date: '2025-11-25',
        sha: 'a09ffb6bb2e990b738ae7b0a9421dfcfa8e1136a'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.4+01',
    version: 'int-v4.3.0-dev.4',
    title: 'Add Process Viewer post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-19',
      date: '2025-11-24',
      issues: [90],
      commit: {
        message: 'Add Process Viewer post-exam application support',
        date: '2025-11-24',
        sha: 'eb8555467b30b9cf1e5590241e6e698ddb08889d'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.3+01',
    version: 'int-v4.3.0-dev.3',
    title: 'Add Special proponent post-exam application support (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-11-19',
      date: '2025-11-20',
      issues: [90],
      commit: {
        message: 'Add Special proponent post-exam application support',
        date: '2025-11-20',
        sha: '3a5546ba7b687931d5a8c28df6a4b8c115d6612c'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.2+05',
    version: 'int-v4.3.0-dev.2',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '05',
      author: 'symeon',
      startDate: '2025-11-18',
      date: '2025-11-18',
      issues: [90],
      commit: {
        message: 'Fix disable post-exam application on Prechecker',
        date: '2025-11-18',
        sha: 'b296e7418af2b77d7475d332a5c3379196f1b14c'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.2+04',
    version: 'int-v4.3.0-dev.2',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '04',
      author: 'symeon',
      startDate: '2025-11-13',
      date: '2025-11-17',
      issues: [90],
      commit: {
        message: 'Add post-exam application history support',
        date: '2025-11-17',
        sha: '064eed43522e50e1e9f3d207a4491e8ce9332ffe'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.2+03',
    version: 'int-v4.3.0-dev.2',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '03',
      author: 'symeon',
      startDate: '2025-11-07',
      date: '2025-11-12',
      issues: [90],
      commit: {
        message: 'Add post-exam application support to Prechecker judgment form',
        date: '2025-11-12',
        sha: '67daf77bc41baff6fa6613c2723984d6f844e1ec'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.2+02',
    version: 'int-v4.3.0-dev.2',
    title: 'Add Prechecker post-exam application support (DEV)',
    build: {
      number: '02',
      author: 'symeon',
      startDate: '2025-11-03',
      date: '2025-11-06',
      issues: [90],
      commit: {
        message: 'Add University Exams menu item on Prechecker role and adapt assign/release dialog',
        date: '2025-11-06',
        sha: '756d613cad0be012f550f539370d8ab2e121b4f0'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.2+01',
    version: 'int-v4.3.0-dev.2',
    title: 'Add create post-exam application button and 7100 app type on filters',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-23',
      date: '2025-10-27',
      issues: [90],
      commit: {
        message: 'Add create post-exam application button and 7100 app type on filters',
        date: '2025-10-27',
        sha: '30ac143bfdc2000f0ea8534aa606a0435706e40a'
      }
    }
  },
  {
    id: 'int-v4.3.0-dev.1+01',
    version: 'int-v4.3.0-dev.1',
    title: 'Add compensatory measures search field and decision column on Application Search form (DEV)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-22',
      date: '2025-10-22',
      issues: [90],
      commit: {
        message: 'Add compensatory measures search field and decision column on Application Search form',
        date: '2025-10-22',
        sha: '1b78576607e809d68580baf38b12742c06da485d'
      }
    }
  },
  {
    id: 'int-v4.2.8+01',
    version: 'int-v4.2.8',
    title: 'Add accessibility widget',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-16',
      date: '2025-10-16',
      issues: [],
      commit: {
        message: 'Add accessibility widget',
        date: '2025-10-16',
        sha: '37a2b52c1b8efe1214700cf44380facdfe88c7b4'
      }
    }
  },
  {
    id: 'int-v4.2.7+01',
    version: 'int-v4.2.7',
    title: 'Add comments on Academic Director judgement (reappraisals) and fix double Prechecker comments',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-10-06',
      date: '2025-10-09',
      issues: [],
      commit: {
        message: 'Add comments on Academic Director judgement (reappraisals) and fix double Prechecker comments',
        date: '2025-10-09',
        sha: '4c1f8a36c4272c5bee70c93aa97c3bd900342897'
      }
    }
  },
  {
    id: 'int-v4.2.6+01',
    version: 'int-v4.2.6',
    title: 'Combined release for #66, #65 and #46 (partial) issues',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-17',
      date: '2025-09-17',
      issues: [],
      commit: {
        message: 'Combined release for #66, #65 and #46 (partial) issues',
        date: '2025-09-17',
        sha: 'f702c84f6abf4e7677e4c566d882b0f79b74b28d'
      }
    }
  },
  {
    id: 'int-v4.2.6-rc.1+01',
    version: 'int-v4.2.6-rc.1',
    title: 'Display full format birthdate field on Application search form (Issue #46 - partial)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-16',
      date: '2025-09-16',
      issues: [],
      commit: {
        message: 'Display full format birthdate field on Application search form (Issue #46 - partial)',
        date: '2025-09-16',
        sha: 'b54ad8fc47573d08e0c6d2766dd37a1253dcf744'
      }
    }
  },
  {
    id: 'int-v4.2.5-rc.1+01',
    version: 'int-v4.2.5-rc.1',
    title: 'Allow reappraisal release from President to Prechecker (Issue #65)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-12',
      date: '2025-09-12',
      issues: [],
      commit: {
        message: 'Allow reappraisal release from President to Prechecker (Issue #65)',
        date: '2025-09-12',
        sha: '53b305c6ec08a423eef22c50c3292bb396bec157'
      }
    }
  },
  {
    id: 'int-v4.2.4-rc.1+01',
    version: 'int-v4.2.4-rc.1',
    title: 'Application return to President from Reappraisal board (Issue #66)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-05',
      date: '2025-09-05',
      issues: [],
      commit: {
        message: 'Application return to President from Reappraisal board (Issue #66)',
        date: '2025-09-05',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.3+01',
    version: 'int-v4.2.3',
    title: 'Fix Council Members missing on President\'s Special Reappraisal Board member selection list (Issue #70)',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-09-05',
      date: '2025-09-05',
      issues: [],
      commit: {
        message: 'Fix Council Members missing on President\'s Special Reappraisal Board member selection list (Issue #70)',
        date: '2025-09-05',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.2+01',
    version: 'int-v4.2.2',
    title: 'Enhance application search form and fix display issues',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-24',
      date: '2025-07-24',
      commit: {
        message: 'Enhance application search form and fix display issues',
        date: '2025-07-24',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.1+01',
    version: 'int-v4.2.1',
    title: 'Fix missing consultants list',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-16',
      date: '2025-07-16',
      commit: {
        message: 'Fix missing consultants list',
        date: '2025-07-16',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0+01',
    version: 'int-v4.2.0',
    title: 'Add reappraisal applications support',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-04',
      date: '2025-07-04',
      commit: {
        message: 'Add reappraisal applications support',
        date: '2025-07-04',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-rc.2+01',
    version: 'int-v4.2.0-rc.2',
    title: 'After first test changes',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-07-01',
      date: '2025-07-01',
      commit: {
        message: 'After first test changes',
        date: '2025-07-01',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-rc.1+01',
    version: 'int-v4.2.0-rc.1',
    title: 'Update President decision\'s feature for reappraisals',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-06-17',
      date: '2025-06-17',
      commit: {
        message: 'Update President decision\'s feature for reappraisals',
        date: '2025-06-17',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-dev.5+01',
    version: 'int-v4.2.0-dev.5',
    title: 'Before reappraisal president\'s decision implementation',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-06-09',
      date: '2025-06-09',
      commit: {
        message: 'Before reappraisal president\'s decision implementation',
        date: '2025-06-09',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-dev.4+01',
    version: 'int-v4.2.0-dev.4',
    title: 'Update Proponent\'s and Academic Director\'s UI and history for reappraisals. Minor fixes',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-05-13',
      date: '2025-05-13',
      commit: {
        message: 'Update Proponent\'s and Academic Director\'s UI and history for reappraisals. Minor fixes',
        date: '2025-05-13',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-dev.3+01',
    version: 'int-v4.2.0-dev.3',
    title: 'Update Reappraisal Board member\'s UI',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-05-03',
      date: '2025-05-03',
      commit: {
        message: 'Update Reappraisal Board member\'s UI',
        date: '2025-05-03',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-dev.2+01',
    version: 'int-v4.2.0-dev.2',
    title: 'Improve President\'s UI on reappraisals. First update Board Member\'s UI',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2025-04-28',
      date: '2025-04-28',
      commit: {
        message: 'Improve President\'s UI on reappraisals. First update Board Member\'s UI',
        date: '2025-04-28',
        sha: ''
      }
    }
  },
  {
    id: 'int-v4.2.0-dev.1+01',
    version: 'int-v4.2.0-dev.1',
    title: 'Reappraisals 2024',
    build: {
      number: '01',
      author: 'symeon',
      startDate: '2024',
      date: '2024',
      commit: {
        message: 'Reappraisals 2024',
        date: '2024',
        sha: ''
      }
    }
  }
]

// Export the current/active release in the format: 'int-v4.3.0 (build 04)'
export const FRONTEND_RELEASE = `${RELEASES[0].version} (build ${RELEASES[0].build.number})`

// Export RELEASES array for use in config
export { RELEASES }



// WEBPACK FOOTER //
// ./src/releases.js